import { Box } from "@chakra-ui/react";
import { Input } from "components";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";
import { observer } from "mobx-react";
import { ChangeEvent, FC, useCallback } from "react";
import { TAutomatedReferralSyncOfficeExtendedData } from "types/automated-referrals.type";

interface IProps {
  record: TAutomatedReferralSyncOfficeExtendedData;
  onChange: (syncPair: TAutomatedReferralSyncOfficeExtendedData) => void;
  placeholder?: string;
}

export const AutomatedReferralOfficeSyncInput: FC<IProps> = observer(
  ({ record, onChange, placeholder }) => {
    const handleChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        onChange({
          ...record,
          membersHubOfficeId: Number(event.target.value) || null,
          syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
        });
      },
      [onChange, record]
    );

    return (
      <Box px={1}>
        <Input
          value={record.membersHubOfficeId || ""}
          placeholder={placeholder || "Enter integration branch ID"}
          onChange={handleChange}
        />
      </Box>
    );
  }
);
